import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
const useElementDimensions = elementRef => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: 0,
      height: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [dimensions, setDimensions] = useState(t0);
  let t1;
  let t2;
  if ($[1] !== elementRef) {
    t1 = () => {
      const getDimensions = () => ({
        width: elementRef.current?.offsetWidth ?? 0,
        height: elementRef.current?.offsetHeight ?? 0
      });
      const handleResize = () => {
        setDimensions(getDimensions());
      };
      if (elementRef.current) {
        setDimensions(getDimensions());
      }
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    };
    t2 = [elementRef];
    $[1] = elementRef;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return dimensions;
};
export default useElementDimensions;